import React, { useEffect, useMemo, useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Row,
  Col,
  Label,
  Button,
  Input,
  FormFeedback,
  Form
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";


const AcademicYearModal = ({
  modal,
  toggle,
  isEdit,
  academicYear,
  trainingTypes,
  onSubmit
}) => {

  // 🔹 Configuration de Formik
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: academicYear?.id || "",
      uuid: academicYear?.uuid || "",
      name: academicYear?.name || "",
      training_type_id: academicYear?.training_type_id || "",
      start_date: academicYear?.start_date || "",
      end_date: academicYear?.end_date || "",
      //description: academicYear?.description || "",
      is_active: academicYear ? !!academicYear.is_active : true, // Par défaut à true pour une nouvelle année
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Veuillez saisir le nom (ex: 2023-2024)"),
      training_type_id: Yup.number().required("Veuillez sélectionner un type"),
      start_date: Yup.date().required("Veuillez saisir la date de début"),
      end_date: Yup.date()
        .required("Veuillez saisir la date de fin")
        .min(Yup.ref('start_date'), "La date de fin doit être après la date de début"),
    }),
    onSubmit: (values) => {
      // Préparation du payload comme dans CourseUnitModal
      const payload = {
        ...values,
        is_active: Boolean(values.is_active)
      };
      onSubmit(payload);

    
    },
  });

    // Sécurité supplémentaire : Reset au changement de mode (Ajout vs Edit)
    useEffect(() => {
      if (modal) {
        if (!isEdit) {
          formik.resetForm();
        }
      }
    }, [modal, isEdit]);
  
  

  return (
    <Modal isOpen={modal} toggle={toggle} backdrop="static" id="staticBackdrop">
      <ModalHeader toggle={toggle} tag="h4">
        {isEdit ? "Modifier - Année académique" : "Ajouter - Année académique"}
      </ModalHeader>
      <ModalBody>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            formik.handleSubmit();
          }}
        >
          <Row>
            <Col className="col-12">
              
              {/* Nom de l'année */}
              <div className="mb-3">
                <Label>Nom</Label>
                <Input
                  name="name"
                  type="text"
                  placeholder="Ex: 2025-2026"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.name}
                  invalid={formik.touched.name && !!formik.errors.name}
                />
                {formik.touched.name && formik.errors.name && (
                  <FormFeedback type="invalid">{formik.errors.name}</FormFeedback>
                )}
              </div>

                <div className="mb-3">
                    <Label>Type de formation</Label>
                    <Input
                        name="training_type_id"
                        type="select"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.training_type_id}
                        invalid={formik.touched.training_type_id && !!formik.errors.training_type_id}
                    >
                        <option value="">Sélectionner un type...</option>
                        {trainingTypes.map((trainingType) => (
                            <option key={trainingType.id} value={trainingType.id}>
                                {trainingType.name}
                            </option>
                        ))}
                    </Input>
                    {formik.touched.training_type_id && formik.errors.training_type_id && (
                        <FormFeedback>{formik.errors.training_type_id}</FormFeedback>
                    )}
                </div>

              {/* Date début */}
              <div className="mb-3">
                <Label>Date début</Label>
                <Input
                  name="start_date"
                  type="date"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.start_date}
                  invalid={formik.touched.start_date && !!formik.errors.start_date}
                />
                {formik.touched.start_date && formik.errors.start_date && (
                  <FormFeedback type="invalid">{formik.errors.start_date}</FormFeedback>
                )}
              </div>

              {/* Date fin */}
              <div className="mb-3">
                <Label>Date fin</Label>
                <Input
                  name="end_date"
                  type="date"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.end_date}
                  invalid={formik.touched.end_date && !!formik.errors.end_date}
                />
                {formik.touched.end_date && formik.errors.end_date && (
                  <FormFeedback type="invalid">{formik.errors.end_date}</FormFeedback>
                )}
              </div>

             

              {/* Statut Active */}
              <div className="mb-3 form-check">
                <Input
                  id="is_active"
                  name="is_active"
                  type="checkbox"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  checked={formik.values.is_active}
                  className="form-check-input"
                />
                <Label for="is_active" className="form-check-label">
                  Définir comme année active
                </Label>
              </div>

            </Col>
          </Row>

          <Row className="mt-2">
            <Col>
              <div className="text-end">
                <Button type="submit" color="primary" className="save-user">
                  {isEdit ? "Mettre à jour" : "Enregistrer"}
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      </ModalBody>
    </Modal>
  );
};

export default AcademicYearModal;